import { ForwardIcon } from '@twistopayments/design-system/icons/inline'

import type {
  Article,
  Category,
  CategoryListResponseDataItemCustom,
} from '@twisto/api-cms'

import { useAdditionalData } from 'homepage/libs/context'

import { ContentListLink } from './content-list-link'
import * as styles from './subcategory-content-list.styles'

const RENDER_ITEMS_LIMIT = 5

/*
  Display 5 articles. If subcategories has nested categories display them
  instead of articles.
*/
export const SubcategoryContentList = (
  category: CategoryListResponseDataItemCustom
) => {
  const articles = category.articles as Article[]
  const categories = category.categories as Category[]

  const uniqueCategories = Array.from(
    new Map(categories.map((item) => [item.path, item])).values()
  )

  const uniqueArticles = Array.from(
    new Map(articles.map((item) => [item.path, item])).values()
  )

  const renderArticles = Math.max(
    RENDER_ITEMS_LIMIT - uniqueCategories.length,
    0
  )

  const { staticTexts } = useAdditionalData()

  const getLinkText = (length: number) => {
    switch (length) {
      case 0:
        return staticTexts?.seeAllArticlesLink?.zero
      case 1:
        return staticTexts?.seeAllArticlesLink?.one
      default:
        return (staticTexts?.seeAllArticlesLink?.other || '').replace(
          '#',
          length.toString()
        )
    }
  }

  return (
    <ul css={styles.articleList}>
      {uniqueCategories.slice(0, RENDER_ITEMS_LIMIT).map((category) => (
        <ContentListLink
          key={category.path}
          text={category.name}
          to={category.path}
        />
      ))}
      {uniqueArticles.slice(0, renderArticles).map((article) => (
        <ContentListLink
          key={article.id}
          text={article.headline}
          to={article.path}
        />
      ))}
      {uniqueArticles.length > renderArticles && (
        <ContentListLink
          fontWeight="medium"
          text={
            <>
              {getLinkText(uniqueArticles.length)}
              <ForwardIcon css={styles.linkIcon} />
            </>
          }
          to={category.path}
        />
      )}
    </ul>
  )
}
